import { useQuery } from '@hooks/reactQuery';

import { getPortalMilestonesAssigneesFilter } from '@api/portalMilestones';

import { extractQueryParams } from '@utils/common';
import { projectUsersFormatted } from '@utils/formatter';

import { TNameTitleValueLabel } from '@interfaces/common/common';

import { refetchOptions } from '@constants/common';
import { PORTAL_MILESTONES_ASSIGNEES_FILTER } from '@constants/queryKeys';

interface IUseQueryMilestonesAssigneesReturned {
	portalMilestonesAssigneesFilter: TNameTitleValueLabel[];
	isLoadingPortalMilestonesAssigneesFilter: boolean;
}

export const useQueryPortalMilestonesAssigneesFilter = (projectId?: string): IUseQueryMilestonesAssigneesReturned => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [PORTAL_MILESTONES_ASSIGNEES_FILTER, projectId],
		queryFn: extractQueryParams(getPortalMilestonesAssigneesFilter),
		select: requestTypes => projectUsersFormatted(requestTypes),
		enabled: [!!projectId],
		...refetchOptions,
	});

	return {
		portalMilestonesAssigneesFilter: data || [],
		isLoadingPortalMilestonesAssigneesFilter: isLoading || isFetching,
	};
};
